
import Hero from "./Hero/Hero"
import Services from "./Services/Services"
import Pathway from "./Pathway/Pathway"
import Youtube from "./Youtube/Youtube"
import TestimonialSlider from "./TestimonialSlider/TestimonialSlider"
import GetInTouch from "./GetInTouch/GetInTouch"
import Blogs from "./Blogs/Blogs.js"
import ContactUs from "./ContactUs/ContactUs.js"
import React from 'react'

const Home = () => {
  return (
    <>
    <Hero />
    <Services />
    <Pathway />
    <Youtube />
    <TestimonialSlider />
    <GetInTouch />
    <Blogs />
    <ContactUs />
    </>
  )
}

export default Home